import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import getLinks from './Utils/Links';
import icons from './Utils/Icons';
import Icon from './Icon/Icon';
import spacing from '../../../theme/shared/spacing';
var StyledList = styled.ul.withConfig({
  displayName: "SocialIcons__StyledList",
  componentId: "i6jfaw-0"
})(["display:flex;list-style-type:none;margin:0 auto ", ";@media ", "{margin-bottom:", ";}padding:0;align-items:center;justify-content:center;"], spacing('l'), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint('small');
}, spacing('xl'));
var StyledItem = styled.li.withConfig({
  displayName: "SocialIcons__StyledItem",
  componentId: "i6jfaw-1"
})(["width:80px;padding:10px;"]);
/** Social media icons with customizable style linked to campaign social media accounts */

var SocialIcons = function SocialIcons(_ref2) {
  var campaign = _ref2.campaign,
      restProps = _objectWithoutProperties(_ref2, ["campaign"]);

  var links = getLinks(campaign);
  return React.createElement(StyledList, null, Object.keys(icons).map(function (brand) {
    return React.createElement(StyledItem, {
      key: brand
    }, React.createElement(Icon, Object.assign({
      icon: icons[brand],
      href: links[brand].url,
      title: links[brand].title,
      brand: brand
    }, restProps)));
  }));
};

SocialIcons.defaultProps = {
  target: 'blank'
};
export default SocialIcons;